import { SVGProps, Ref, forwardRef } from 'react';

export const PinCrossedFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m13.308 6.534-1.887 1.887-3.846-3.846 1.887-1.887L8.26 1.486l.99-.99 6.25 6.25-.99.99z"
                fill="currentColor"
            />
            <path
                d="m.5 1.5 1-1 14 14-1 1-4.253-4.253a4.08 4.08 0 0 1-1.167 3.36l-.721.723-3.348-3.348L1.5 15.5l-1-1 3.521-3.508L.667 7.638l.722-.723a4.08 4.08 0 0 1 3.36-1.165z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PinCrossedFilledSize16Glyph.displayName = 'PinCrossedFilledSize16Glyph';
